import type { SlideConfig } from '@/lib/types';

// Import layout components (will be created)
import { TitleSlide } from './TitleSlide';
import { NarrativeSlide } from './NarrativeSlide';
import { SplitSlide } from './SplitSlide';
import { ConceptPairSlide } from './ConceptPairSlide';
import { ConceptTrioSlide } from './ConceptTrioSlide';
import { ScenarioSlide } from './ScenarioSlide';
import { ComparisonSlide } from './ComparisonSlide';
import { BuildUpSlide } from './BuildUpSlide';
import { QuoteSlide } from './QuoteSlide';
import { SynthesisSlide } from './SynthesisSlide';
import { InteractiveSlide } from './InteractiveSlide';
import { VideoSlide } from './VideoSlide';
import { VisualSlide } from './VisualSlide';

interface SlideLayoutRouterProps {
  slide: SlideConfig;
  accentColor: string;
}

export function SlideLayoutRouter({ slide, accentColor }: SlideLayoutRouterProps) {
  const commonProps = {
    title: slide.title,
    content: slide.content,
    accentColor,
  };

  switch (slide.layout) {
    case 'title':
      return <TitleSlide {...commonProps} />;

    case 'narrative':
      return <NarrativeSlide {...commonProps} />;

    case 'split':
      return <SplitSlide {...commonProps} />;

    case 'concept-pair':
      return <ConceptPairSlide {...commonProps} />;

    case 'concept-trio':
      return <ConceptTrioSlide {...commonProps} />;

    case 'scenario':
      return <ScenarioSlide {...commonProps} />;

    case 'comparison':
      return <ComparisonSlide {...commonProps} />;

    case 'build-up':
      return <BuildUpSlide {...commonProps} />;

    case 'quote-highlight':
      return <QuoteSlide {...commonProps} />;

    case 'synthesis':
      return <SynthesisSlide {...commonProps} />;

    case 'interactive':
      return <InteractiveSlide {...commonProps} />;

    case 'video':
      return <VideoSlide {...commonProps} />;

    case 'visual':
      return <VisualSlide {...commonProps} />;

    default:
      return (
        <div className="slide-content">
          <h2 className="text-3xl font-serif font-bold mb-6">{slide.title}</h2>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
            <p className="text-sm font-medium text-yellow-800">
              Unknown layout type: <code>{slide.layout}</code>
            </p>
          </div>
          <pre className="bg-slate-100 p-4 rounded-lg overflow-auto text-sm">
            {JSON.stringify(slide.content, null, 2)}
          </pre>
        </div>
      );
  }
}
